import React from 'react';
import { MainLayout } from '../layouts/MainLayout';
import { Card } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
import { Button } from '../components/ui/Button';
import { SystemUpdate } from '../types';
import { RefreshCw, Check, AlertTriangle } from 'lucide-react';
const mockUpdates: SystemUpdate[] = [{
  id: '1',
  systemName: 'SRV-DC-01',
  type: 'Server',
  client: 'Müller GmbH',
  currentVersion: 'Win Server 2019',
  availableVersion: 'Security Patch KB5031',
  status: 'critical_update'
}, {
  id: '2',
  systemName: 'FW-HQ-01',
  type: 'Firewall',
  client: 'Schmidt KG',
  currentVersion: 'v12.5.4',
  availableVersion: 'v12.6.0',
  status: 'update_available'
}, {
  id: '3',
  systemName: 'NB-001-MÜLLER',
  type: 'Notebook',
  client: 'Müller GmbH',
  currentVersion: 'Win 10 21H2',
  availableVersion: 'Win 10 22H2',
  status: 'up_to_date'
}, {
  id: '4',
  systemName: 'SW-CORE-01',
  type: 'Switch',
  client: 'Schmidt KG',
  currentVersion: 'fw-1.8.0',
  availableVersion: 'fw-1.9.2',
  status: 'update_available'
}];
interface UpdateManagementProps {
  onLogout: () => void;
}
export function UpdateManagement({
  onLogout
}: UpdateManagementProps) {
  return <MainLayout title="Update Verwaltung" onLogout={onLogout} data-id="element-1661">
      <Card data-id="element-1662">
        <div className="overflow-x-auto" data-id="element-1663">
          <table className="w-full text-sm text-left" data-id="element-1664">
            <thead className="text-xs text-slate-500 uppercase bg-slate-50 border-b border-slate-200" data-id="element-1665">
              <tr data-id="element-1666">
                <th className="px-4 py-3 font-medium" data-id="element-1667">System</th>
                <th className="px-4 py-3 font-medium" data-id="element-1668">Kunde</th>
                <th className="px-4 py-3 font-medium" data-id="element-1669">Aktuelle Version</th>
                <th className="px-4 py-3 font-medium" data-id="element-1670">Verfügbar</th>
                <th className="px-4 py-3 font-medium" data-id="element-1671">Status</th>
                <th className="px-4 py-3 font-medium text-right" data-id="element-1672">Aktionen</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-1673">
              {mockUpdates.map(update => <tr key={update.id} className="hover:bg-slate-50 transition-colors" data-id="element-1674">
                  <td className="px-4 py-3" data-id="element-1675">
                    <div className="font-medium text-slate-900" data-id="element-1676">
                      {update.systemName}
                    </div>
                    <div className="text-xs text-slate-500" data-id="element-1677">{update.type}</div>
                  </td>
                  <td className="px-4 py-3 text-slate-600" data-id="element-1678">{update.client}</td>
                  <td className="px-4 py-3 font-mono text-xs text-slate-600" data-id="element-1679">
                    {update.currentVersion}
                  </td>
                  <td className="px-4 py-3 font-mono text-xs text-slate-600" data-id="element-1680">
                    {update.availableVersion}
                  </td>
                  <td className="px-4 py-3" data-id="element-1681">
                    {update.status === 'up_to_date' && <Badge variant="success" data-id="element-1682">Aktuell</Badge>}
                    {update.status === 'update_available' && <Badge variant="warning" data-id="element-1683">Update verfügbar</Badge>}
                    {update.status === 'critical_update' && <Badge variant="error" data-id="element-1684">Kritisch</Badge>}
                  </td>
                  <td className="px-4 py-3 text-right" data-id="element-1685">
                    {update.status !== 'up_to_date' && <Button size="sm" leftIcon={<RefreshCw className="h-3 w-3" data-id="element-1687" />} data-id="element-1686">
                        Update starten
                      </Button>}
                    {update.status === 'up_to_date' && <span className="text-emerald-600 flex items-center justify-end gap-1 text-xs" data-id="element-1688">
                        <Check className="h-3 w-3" data-id="element-1689" /> Geprüft
                      </span>}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>
    </MainLayout>;
}